import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { processType } from '../../../constants/options.constant';
import { useStore } from '../../../contexts/store-provider';
import {
  IAddProcess,
  IUpdateProcess,
} from '../../../models/forms/IAddUpdateProcess';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IProcessVM } from '../../../models/response/IProcessResponse';
import { formatMessage } from '../../../translations/format-message';
import AddProcessForm from '../forms/add-edit-process-form';

const AddProcess = (props: IFormModalProps) => {
  const { processStore } = useStore();
  const {
    AddProcessService,
    UpdateProcessService,
    GetProcessByIdService,
    resetAddUpdateProcessState,
    resetProcessDetail,
    addUpdateProcessState,
    processDetails,
  } = processStore;
  const initialValues: IAddProcess | IUpdateProcess = processDetails;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetProcessByIdService(props.id);
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateProcessState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateProcessState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateProcessState.error) {
      toast.error(formatMessage(addUpdateProcessState.error));
      resetAddUpdateProcessState();
    }
  }, [addUpdateProcessState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({
    ProcessName,
    Type,
    Comment,
    ShortName,
  }: IProcessVM) => {
    var addObj: IAddProcess = {
      ProcessName: ProcessName.trim(),
      Type: Type,
      Comment: Comment,
      ShortName: ShortName.trim(),
    };

    var updateObj: IUpdateProcess = {
      Id: props.id,
      ProcessName: ProcessName.trim(),
      Type: Type,
      Comment: Comment,
      ShortName: ShortName.trim(),
    };

    if (props.id < 0) {
      AddProcessService(addObj);
    } else {
      UpdateProcessService(updateObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetProcessDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <AddProcessForm
        id={props.id}
        initialValues={initialValues}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={addUpdateProcessState.inProgress}
        processTypeOptions={processType}
      />
    </React.Fragment>
  );
};

export default observer(AddProcess);
